import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import type { MailboxRow } from '../../../music24/outreach/outreachTypes';
import { mailboxMessages as messages } from './mailboxMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Mailboxes card; each part uses its own slice of it */
import styles from './Mailboxes.module.scss';

const bold = (chunks: React.ReactNode[]) => <b>{chunks}</b>;

interface TodayMeterProps {
  mailbox: Pick<MailboxRow, 'health' | 'sentToday' | 'capToday'>;
}

/** "N of M sent today" with a meter (design outreach-v2 q3), for a mailbox past its warm-up. */
const TodayMeterComponent: React.FC<TodayMeterProps> = ({ mailbox }) => {
  const intl = useIntl();
  const sending = mailbox.health === 'ok' || mailbox.health === 'warming';
  const share = mailbox.capToday > 0 ? Math.min(100, Math.round((mailbox.sentToday / mailbox.capToday) * 100)) : 0;
  return (
    <div className={styles.meterBlock} data-testid="mailbox-today">
      <div className={styles.meterTop}>
        <span>{intl.formatMessage(sending ? messages.ready : messages.notSending)}</span>
        <span>
          {intl.formatMessage(messages.sentToday, { sent: mailbox.sentToday, cap: mailbox.capToday, b: bold })}
        </span>
      </div>
      <div className={styles.meter}>
        {/* The width is data: the share of today's cap that went out. */}
        <span style={{ width: `${sending ? share : 0}%` }} />
      </div>
    </div>
  );
};

export const TodayMeter = TypedMemo(TodayMeterComponent);
